export default __webpack_public_path__ + "static/media/rating_active_4.b6a21c51.png";